export default "__VITE_ASSET__fcf297cb__"